import { isDefined } from "@clipboard-health/util-ts";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useGetMostRelevantChartingNoncompliance } from "../api/useGetMostRelevantChartingNoncompliance";
import { ChartingRecallCard } from "./ChartingRecallCard";
import { ChartingReviewCard } from "./ChartingReviewCard";
import { ChartingViolationCard } from "./ChartingViolationCard";

export function ChartingCard() {
  const { userId: workerId } = useDefinedWorker();
  const { chartingNoncompliance, noncomplianceExists, isInReview, isInViolation } =
    useGetMostRelevantChartingNoncompliance({
      workerId,
    });

  if (!isDefined(chartingNoncompliance) || !noncomplianceExists) {
    return null;
  }

  if (isInReview) {
    return <ChartingReviewCard chartingNoncompliance={chartingNoncompliance} />;
  }

  if (isInViolation) {
    return <ChartingViolationCard chartingNoncompliance={chartingNoncompliance} />;
  }

  return <ChartingRecallCard chartingNoncompliance={chartingNoncompliance} />;
}
